import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import type { ReactNode } from "react";
import { cn } from "cn";
import { RoutedLink } from "../components/RoutedLink.tsx";

interface ErrorStateBackLinkProps {
    href: string;
    children: ReactNode;
    className?: string;
}

export function ErrorStateBackLink({ href, children, className }: ErrorStateBackLinkProps) {
    return (
        <RoutedLink href={href} className={cn("text-muted-foreground inline-flex items-center gap-1.5 text-sm font-medium", className)} data-public>
            <ArrowLeftIcon aria-hidden="true" className="size-4 shrink-0" />
            {children}
        </RoutedLink>
    );
}
